import { BaseService, Service } from "/@/cool";
@Service("modelExpressOrder")
class ModelExpressOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["info"] = prefix + "info";
		this.permission["page"] = prefix + "page";
		this.permission["manualSign"] = prefix + "manualSign";
	}

	manualSign(data: any) {
		return this.request({
			url: "/manualSign",
			method: "POST",
			data
		});
	}
}
export default ModelExpressOrder;
